import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '@/features/dialog/dialogSlice';
import { useListInformedConsentsQuery } from '@/features/clients/clientsApi';
import { useObjectContext } from '@/hooks/useObjectContext';
import { InformedConsentHistoryTable } from './InformedConsentHistoryTable';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

export const InformedConsentHistoryDialog = () => {
	const dispatch = useDispatch();

	const { clientId } = useObjectContext();

	const open = useSelector((state) => state.dialog.open?.informedConsentHistory);

	const { getFeatureFlags } = useFeatureFlagContext();
	const informedConsentEnabled = Boolean(getFeatureFlags('informedConsent')?.active);

	const isOpen = open && informedConsentEnabled;

	const { data: records = [], isLoading } = useListInformedConsentsQuery(clientId, {
		skip: !clientId || !open || !informedConsentEnabled,
	});

	const handleClose = () => dispatch(closeDialog('informedConsentHistory'));

	return (
		<Dialog open={isOpen} onClose={handleClose} maxWidth='md' fullWidth>
			<DialogTitle>View history</DialogTitle>
			<DialogContent>
				<InformedConsentHistoryTable records={records} isLoading={isLoading} />
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};
